document.addEventListener("DOMContentLoaded", function () {
  const productCards = document.querySelectorAll('.Dynamic-Card');

  productCards.forEach(card => {
    const combobox = card.querySelector('.Dynamic-Select-Container');
    const radioWrapper = card.querySelector('.Dynamic-Input-Radio-Wrapper');
    const productType = card.dataset.productType;
    const cardCtaButton = card.querySelector('.Dynamic-Card-Expanded-CTA-Button');

    if (!combobox && !radioWrapper) return;

    // Parse the full product variants JSON safely
    const productData = JSON.parse(card.dataset.productJson || "[]");
    
    if (["OMR Deep Dive", "OMR Deep Dive Einzelsession"].includes(productType)) {
      initializeDeepDive(card, combobox, radioWrapper, cardCtaButton, productData);
    } else if (["OMR Report"].includes(productType)) {
      initializeReport(card, radioWrapper, cardCtaButton);
    } else if (["OMR Academy", "OMR Academy Kompakt", "CSD"].includes(productType)) {
      initializeAcademy(card, combobox, cardCtaButton, productData);
    } else if (["OMR UpSkill"].includes(productType)) {
      initializeUpskill(card, cardCtaButton, productData);
    } else if (["OMR Education Unlimited"].includes(productType)) {
      initializeUnlimited(card, cardCtaButton, productData);
    }
  });
});

function initializeDeepDive(card, combobox, radioWrapper, cardCtaButton, productData) {
  
  const radioButtons = card.querySelectorAll(`input[name="${card.dataset.id}"]`);

  const getSelectedVariant = () => {
    const selectedRadio = card.querySelector(`input[name="${card.dataset.id}"]:checked`);
    const selectedOption = combobox
      ? combobox.querySelector('.Dynamic-Select-Option[aria-selected="true"]')
      : null;

    if (selectedRadio) {
      if (selectedOption) {
        return productData.find(variant =>
          variant.option2 === selectedRadio.value && variant.option1 === selectedOption.dataset.value
        );
      } else {
        return productData.find(variant => variant.option2 === selectedRadio.value);
      }
    }
    return null;
  };

  const updateButtonAttributes = () => {
    const selectedVariant = getSelectedVariant();
    if (selectedVariant) {
      cardCtaButton.setAttribute('data-variantid', selectedVariant.id);
      cardCtaButton.setAttribute('data-sku', selectedVariant.sku);
    }
  };

  radioButtons.forEach(radio => radio.addEventListener('change', updateButtonAttributes));

  if (combobox) {
    const selectTextfield = combobox.querySelector('.Dynamic-Select-Textfield-Wrapper');
    const dropdownWrapper = combobox.querySelector('.Dynamic-Select-Dropdown-Wrapper');
    const selectContent = combobox.querySelector('.Dynamic-Select-Textfield-Content');
    const options = dropdownWrapper.querySelectorAll('.Dynamic-Select-Option');

    setupComboboxEvents(combobox, selectTextfield, dropdownWrapper, selectContent, options, updateButtonAttributes);
  }
}


function initializeReport(card, radioWrapper, cardCtaButton) {
  
 const reportRadioWrapper = card.querySelector('.Dynamic-Card-Expanded-Bottom-Wrapper.Report');
  const radioButtons = card.querySelectorAll(`input[name="${card.dataset.id}"]`);

  const updateButtonAttributes = () => {
    const selectedRadio = card.querySelector(`input[name="${card.dataset.id}"]:checked`);
    const radioId = selectedRadio.value;
    const radioSku = selectedRadio.dataset.productSku;
    cardCtaButton.setAttribute('data-variantid', radioId);
    cardCtaButton.setAttribute('data-sku', radioSku);
    
  };

  radioButtons.forEach(radio => {
    radio.addEventListener('change', updateButtonAttributes);
  });
}


function initializeAcademy(card, combobox, cardCtaButton, productData) {
  
  const radioButtons = card.querySelectorAll(`input[name="${card.dataset.id}"]`); 
  const selectTextfield = combobox ? combobox.querySelector('.Dynamic-Select-Textfield-Wrapper') : null;
  const dropdownWrapper = combobox ? combobox.querySelector('.Dynamic-Select-Dropdown-Wrapper') : null;
  const selectContent = combobox ? combobox.querySelector('.Dynamic-Select-Textfield-Content') : null;
  const options = dropdownWrapper ? dropdownWrapper.querySelectorAll('.Dynamic-Select-Option') : [];

  const getSelectedVariant = () => {
    const selectedRadio = card.querySelector(`input[name="${card.dataset.id}"]:checked`);
    const selectedOption = combobox
      ? dropdownWrapper.querySelector('.Dynamic-Select-Option[aria-selected="true"]')
      : null;

    if (selectedRadio) {
      if (selectedOption) {
        return productData.find(variant =>
          variant.option2 === selectedRadio.value && variant.option1 === selectedOption.dataset.value
        );
      } else {
        return productData.find(variant => variant.option1 === selectedRadio.value);
      }
    } else if (selectedOption) {
      return productData.find(variant => variant.option1 === selectedOption.dataset.value);
    }
    return null;
  };

  const updateButtonAttributes = () => {
    const selectedVariant = getSelectedVariant();
    if (selectedVariant) {
      cardCtaButton.setAttribute('data-variantid', selectedVariant.id);
      cardCtaButton.setAttribute('data-sku', selectedVariant.sku);
    }
  };

  if (radioButtons.length > 0) {
    radioButtons.forEach(radio => radio.addEventListener('change', updateButtonAttributes));
  }

  if (combobox) {
    setupComboboxEvents(combobox, selectTextfield, dropdownWrapper, selectContent, options, updateButtonAttributes);
  }
}

function initializeUpskill(card, cardCtaButton, productData) {


  
}

function initializeUnlimited(card, cardCtaButton, productData) {


  
}



function setupComboboxEvents(combobox, selectTextfield, dropdownWrapper, selectContent, options, updateButtonAttributes) {
  const toggleClass = (element, className, add) => {
    if (element) add ? element.classList.add(className) : element.classList.remove(className);
  };

  selectTextfield.addEventListener('click', () => {
    const isExpanded = combobox.getAttribute('aria-expanded') === "true";
    combobox.setAttribute('aria-expanded', !isExpanded);
    dropdownWrapper.classList.toggle('show');
  });

  dropdownWrapper.addEventListener('click', (e) => {
    const option = e.target.closest('.Dynamic-Select-Option');
    if (option) {
      selectContent.textContent = option.querySelector('.Dynamic-Select-Option-Text').textContent;
      options.forEach(opt => opt.setAttribute('aria-selected', 'false'));
      option.setAttribute('aria-selected', 'true');
      combobox.setAttribute('aria-expanded', 'false');
      dropdownWrapper.classList.remove('show');
      updateButtonAttributes();
    }
  });

  document.addEventListener('click', (e) => {
    if (!selectTextfield.contains(e.target)) {
      combobox.setAttribute('aria-expanded', 'false');
      dropdownWrapper.classList.remove('show');
    }
  });
}



function triggerTNEingabe(element){

    const productId = element.getAttribute("data-productid");
    const variantId = element.getAttribute("data-variantid");
    const productType = element.getAttribute("data-type").toLowerCase();
    const sku = element.getAttribute("data-sku");

    let userMessage = element.getAttribute("data-custommessage");
    let headline;
    let subHeadline;

    if(!userMessage){

        if(productType.includes("deep dive") || productType.includes("einzelsession")){

            headline = "Fast geschafft!";
            subHeadline = "Bitte teile uns mit, für wen du die Tickets kaufen möchtest. Achte dabei auf eine korrekte Eingabe aller Daten, da wir die Zugänge zum Online-Seminar nach dem Kauf an diese E-Mail-Adressen verschicken. Wird der Kurs nicht von deiner Firma bezahlt, trage bei Unternehmen bitte Privat ein.";

        }

        if(productType.includes("unlimited")){

            headline = "Fast geschafft!";
            subHeadline = "Bitte teile uns mit, für wen du OMR Education Unlimited buchen möchtest. Achte dabei auf eine korrekte Eingabe aller Daten, da wir im Anschluss an deine Buchung die Kunden-Accounts anlegen und die E-Mails versenden. Wird der Zugang nicht von deiner Firma bezahlt, trage bei Unternehmen bitte Privat ein. Die Zugänge sind personengebunden.";


        }





    }else{

        //modify 
        userMessage = userMessage.split("</h2>");
        headline = userMessage[0].replace("<h2 class='heading'>","");
        subHeadline = userMessage[1].replace("<p class='custom-user-message'>","");
        subHeadline = subHeadline.replace("</p>","");


    }






    let cartProperties = document.getElementById("participantData__DataStore").getAttribute("data-cart");


    if(productType === "omr report"){



    addReportToCart(variantId, productId);



    } else if (productId == "8309784772872" || productId == "8309783265544" || productId == "8309786476808" || productId == "8309786280200" || productId == "8309783757064" || productId == "9555298681096") {
      
      addVoucherToCart(variantId, productId);
      
    } else{


        let dialogSettings = {
            "source": "product",
            "action": "open",
            "variantId": variantId,
            "productId": productId,
            "quantity": 1,
            "sku": sku,
            "fastselectdata": cartProperties,
            "headline": headline,
            "subHeadline": subHeadline,
            "productType": productType,
            "productJson": ""
        };

        openCloseDialog(dialogSettings);




    }






}

function addReportToCart( variantId, productId ) {

    let recommendedProductHandle;

    getFirstRecommendedProductHandle(productId, function(handle) {
        if (handle) {

            recommendedProductHandle = handle;

        } else {

        }
    });


    let data = {
        "id": variantId,
        "quantity": 1

    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true  //this code is for prestige theme, is to refresh the cart
            }));




            openCartDrawer();

            pushEventToDataLayer("reportAddToCart", "", window.location.href, "");

            //remove this later, just for the AB Test to add all addToCarts under the same event
            pushEventToDataLayer("participantFormAddToCart", "", window.location.href, "");

            if(window.location.href.includes("recommendedProduct=true")){

                pushEventToDataLayer("recommendedProductAddToCart", "", window.location.href, "");

            }

            //if a recommended product was found for the product which was just added to the cart
            if(recommendedProductHandle){

                //throw the custom event to trigger the recommendedProductCode
                const recommendedProductEvent = new CustomEvent('recommendedProduct', {
                    detail: {

                        productId: productId,
                        handle: recommendedProductHandle,
                        source: ""
                    }
                });

                //throw the event
                window.dispatchEvent(recommendedProductEvent);


            }






        }

    });

}





function addVoucherToCart( variantId, productId ) {

    let recommendedProductHandle;

    getFirstRecommendedProductHandle(productId, function(handle) {
        if (handle) {
            recommendedProductHandle = handle;
        } else {

        }
    });

    let data = {
        "id": variantId,
        "quantity": 1

    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true  //this code is for prestige theme, is to refresh the cart
            }));

            openCartDrawer();

            pushEventToDataLayer("voucherAddToCart", "", window.location.href, "");

            //remove this later, just for the AB Test to add all addToCarts under the same event
            pushEventToDataLayer("participantFormAddToCart", "", window.location.href, "");

            if(window.location.href.includes("recommendedProduct=true")){
                pushEventToDataLayer("recommendedProductAddToCart", "", window.location.href, "");
            }

            //if a recommended product was found for the product which was just added to the cart
            if(recommendedProductHandle){

                //throw the custom event to trigger the recommendedProductCode
                const recommendedProductEvent = new CustomEvent('recommendedProduct', {
                    detail: {

                        productId: productId,
                        handle: recommendedProductHandle,
                        source: ""
                    }
                });

                //throw the event
                window.dispatchEvent(recommendedProductEvent);
            }
        }
    });
}